import axios from "axios";
//const jipvioApiBase = process.env.JIPVIO_API_BASE;
const baseUriUserSrv = `${process.env.VUE_APP_BASE_URL}/jipviomain/api/v1/user`;
//const baseUriUserSrv = `http://localhost:9083/jipviomain/api/v1/user`;

export default {
  getOauthUserInfo(authProvider, code) {
    return axios({
      method: "get",
      url: `${baseUriUserSrv}/oauth/user/info`,
      params: {
        authProvider: authProvider,
        code: code
      },
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getUserInfoFromKakao(access_token) {
    return axios({
      method: "get",
      url: "https://kapi.kakao.com/v2/user/me",
      headers: {
        Authorization: `Bearer ${access_token}`
      },
      validateStatus: () => true,
      timeout: 6000,
      crossDomain: true
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getAuthTokenFromKakao(authInfo) {
    return axios({
      method: "post",
      url: "https://kauth.kakao.com/oauth/token",
      params: {
        grant_type: authInfo.grantType,
        client_id: authInfo.clientId,
        redirect_uri: authInfo.redirectUri,
        code: authInfo.code
      },
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  logout() {
    return axios({
      method: "delete",
      url: baseUriUserSrv + `/invalidate`,
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  login(loginInfo) {
    return axios({
      method: "post",
      url: baseUriUserSrv + `/auth`,
      params: {
        returnUserInfo: true
      },
      data: {
        authProviderId: loginInfo.authProviderId,
        code: loginInfo.code,
        email: loginInfo.email,
        password: loginInfo.password
      },
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  getUser(userInfo) {
    return axios({
      method: "get",
      url: baseUriUserSrv,
      params: {
        authProviderId: userInfo.authProviderId,
        uid: userInfo.uid,
        email: userInfo.email
      },
      // `validateStatus`는 주어진 HTTP 응답 상태 코드에 대한 약속을 해결할지 거절 할지를 정의합니다.
      // `validateStatus`가`true`를 반환하면 (또는`null`,`undefined`) promise를 resolve 합니다.
      // 그렇지 않으면 promise가 reject 됩니다.
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  saveUser(userInfo) {
    return axios({
      method: "post",
      url: baseUriUserSrv,
      data: {
        primaryKey: {
          uid: userInfo.uid,
          authProviderId: userInfo.authProviderId
        },
        authToken: userInfo.authToken,
        type: userInfo.type,
        email: userInfo.email,
        password: userInfo.password,
        birthDt: userInfo.birthDt,
        phoneNo: userInfo.phoneNo,
        gender: userInfo.gender,
        name: userInfo.name,

        notiEmail: userInfo.EmForNotice,
        agRegNum: userInfo.officeRegNum,
        agName: userInfo.officeName,
        agCeoName: userInfo.ceoName,
        upldId: userInfo.upldId,
        termAgreeYn: userInfo.termAgreeYn
      },
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  },
  removeUser(authProviderId, uid) {
    return axios({
      method: "delete",
      url: baseUriUserSrv + `/${authProviderId}/${uid}`,
      validateStatus: () => true,
      timeout: 6000
    })
      .then(res => {
        return {
          status: res.status,
          payload: res.data.payload,
          message: res.data.message,
          detail: res.data.detail
        };
      })
      .catch(err => {
        console.error(err);
        return {
          status: 500,
          message: "서버통신 오류",
          detail: {
            code: -1,
            message: "서버통신 오류"
          }
        };
      });
  }
};
